import { IconType } from 'components/Icon';
import Section from 'components/Panel/Section';
import TextInput from 'components/Widget/Input/TextInput';
import { Style, Typography } from 'dragonmouse-shared/style';
import { MenuItemAction } from 'menu/MenuItem';
import React from 'react';
import { useDispatch } from 'react-redux';
import { showContextMenu } from 'redux/mode/actions';
import { displayViewOnlyModal } from 'redux/mode/util';
import * as Panel from '../../../styles';
import * as DS from '../styles';

interface TypeSetupProps {
	activeStyle: Style;
	updateCurrentStyle: (update: Partial<Style>) => void;
	viewOnly?: boolean;
}
const TypeSetup = ({ activeStyle, updateCurrentStyle, viewOnly }: TypeSetupProps) => {
	const dispatch = useDispatch();

	const onAddType = () => {
		if (viewOnly) {
			displayViewOnlyModal();
			return;
		}
		if (!activeStyle) return;
		const typography: Typography = {
			title: '',
			value: '',
		};
		updateCurrentStyle({ typography: [...(activeStyle.typography || []), typography] });
	};

	const onTypeContextMenu = (e: React.MouseEvent, index: number) => {
		if (!activeStyle) return;
		if (e.target instanceof HTMLElement) {
			dispatch(
				showContextMenu({
					point: { x: e.clientX, y: e.clientY },
					menuItems: [
						new MenuItemAction('Delete type spec', '', () => {
							updateCurrentStyle({
								typography: activeStyle.typography.filter((_, i) => i !== index),
							});
						}),
					],
				})
			);
		}
	};

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<Section
			label="Typography"
			actions={[
				{
					tooltip: 'Add type spec',
					icon: IconType.ADD,
					onClick: onAddType,
				},
			]}
		>
			{activeStyle?.typography?.map((typography, index) => (
				<DS.PropertyRow key={index} onContextMenu={(e) => onTypeContextMenu(e, index)}>
					<DS.PropertyLabel>
						<TextInput
							value={typography.title}
							placeholder="e.g. 'Body'"
							onChange={(e) => {
								if (viewOnly) {
									displayViewOnlyModal();
									return;
								}
								updateCurrentStyle({
									typography: activeStyle.typography.map((c, i) =>
										i === index ? { ...c, title: e.target.value } : c
									),
								});
							}}
						/>
					</DS.PropertyLabel>
					<DS.PropertySpacer />
					<DS.PropertyLabel>
						<TextInput
							value={typography.value}
							placeholder="e.g. 'Arial Bold 14pt'"
							onChange={(e) => {
								if (viewOnly) {
									displayViewOnlyModal();
									return;
								}
								updateCurrentStyle({
									typography: activeStyle.typography.map((c, i) =>
										i === index ? { ...c, value: e.target.value } : c
									),
								});
							}}
						/>
					</DS.PropertyLabel>
				</DS.PropertyRow>
			))}
			{activeStyle?.typography?.length > 0 ? <Panel.Spacer /> : <Panel.HalfSpacer />}
		</Section>
	);
};

export default TypeSetup;
